import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { postRequest, deleteRequest, tabulatorGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon, CalendarIcon } from "../svg/svgIcons";
import { useReactToPrint } from "react-to-print";
import { InfinitySpin } from 'react-loader-spinner';
import { DateTime } from "luxon";
import AuthContext from "../../components/AuthContext";
import moment from "moment";
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../components/UtilContext";
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { extractSafePaginationParams, createDedupedAjaxRequest, cleanSorters, refreshProgressiveFromStart } from '../../utils/tabulatorProgressiveLoading';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
import { toLocalDateString } from '../../utils/previewDateRange';
const PAINTING_CONDITION_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'outdoor_temp': 'PaintingConditionList.Column.OutdoorTemp',
  'indoor_temp': 'PaintingConditionList.Column.IndoorTemp',
  'outdoor_hum': 'PaintingConditionList.Column.OutdoorHum',
  'indoor_hum': 'PaintingConditionList.Column.IndoorHum',
  'weather': 'PaintingConditionList.Column.Weather',
  'ph_probe': 'PaintingConditionList.Column.PhProbe',
  'ph_phosphate': 'PaintingConditionList.Column.PhPhosphate',
  'temp_check': 'PaintingConditionList.Column.TempCheck',
  'nacl_check': 'PaintingConditionList.Column.NaclCheck',
  'note': 'PaintingConditionList.Column.Note',
  'state': 'PaintingConditionList.Column.State',
  'custom_date': 'PaintingConditionList.Column.DateTime',
  'id': 'PaintingConditionList.Column.OutdoorTemp',
});


window.DateTime = DateTime;

export default function PaintingConditionList({ preview = null, timePeriod = null, date = null, records = null, countType = null }) {

    const [state, dispatch] = useContext(DatabaseContext);
    const { user } = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,formatDate, openChosenNotificationPreferences} = useContext(UtilContext);

    const [insertIcon,setInsertIcon] = useState(!user.permissions?.includes("add painting"));
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [printVisible,setPrintVisible] = useState(false);
    const [printValue,setPrintValue] = useState("Zoznam");
    const [visibleCalendar,setVisibleCalendar] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const [markUnmark, setMarkUnmarked] = useState(true);

    const DEFAULT_COLUMNS_VISIBLE_PAINTING_CONDITION = { outdoor_temp: true, indoor_temp: true, outdoor_hum: true, indoor_hum: true, weather: true, ph_probe: true, ph_phosphate: true, note: true, temp_check: true, nacl_check: true, state: true, custom_date: true };
    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_PAINTING_CONDITION });
    const [maskVisible, setMaskVisible] = useState(false);
const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);

  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: PAINTING_CONDITION_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table?.rowManager?.element) return;
        const holder = table.rowManager.element;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);

    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table?.rowManager?.element) return;
        const holder = table.rowManager.element;
        const header = table.columnManager?.contentsElement;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
        if (extra.size == null) extra.size = pageSizePc;
        const sorters = cleanSorters(paramsFromTabulator?.sorters ?? getTable()?.getSorters?.() ?? []);
        if (sorters?.length) extra.sorters = JSON.stringify(sorters);
        const t = getTable();
        const hf = t?.getHeaderFilters?.() ?? [];
        hf.forEach(f => {
            if (f?.field != null && f.value != null && String(f.value).trim() !== '') {
                extra['filter_' + f.field] = String(f.value).trim();
            }
        });
        if (preview != null && preview !== '') extra.preview_segment = preview;
        if (timePeriod != null && timePeriod !== '') extra.time_period = timePeriod;
        if (date != null) {
            if (Array.isArray(date)) {
                const d0 = date[0] instanceof Date ? date[0] : new Date(date[0]);
                extra.date = toLocalDateString(d0) ?? date[0];
            } else {
                const d = date instanceof Date ? date : new Date(date);
                extra.date = toLocalDateString(d) ?? date;
            }
        }
        if (Array.isArray(date) && date.length >= 2) {
            const d0 = date[0] instanceof Date ? date[0] : new Date(date[0]);
            const d1 = date[1] instanceof Date ? date[1] : new Date(date[1]);
            extra.date_from = toLocalDateString(d0);
            extra.date_to = toLocalDateString(d1);
        }
        if (countType != null && countType !== '') extra.count_type = countType;
        if (records != null && Array.isArray(records) && records.length > 0) {
            extra.record_ids = records.map(r => r.id).join(',');
        }
        if (searchValue && String(searchValue).trim() !== '') extra.search = String(searchValue).trim();
        if (fromDate && fromDate !== '') extra.date_from = fromDate;
        if (toDate && toDate !== '') extra.date_to = toDate;
        return extra;
    }, [pageSizePc, preview, timePeriod, date, countType, records, searchValue, fromDate, toDate, getTable]);

    const fetchPaged = useCallback((url, merged) => {
        return tabulatorGet(url, merged).then((r) => ({
            data: r?.data ?? [],
            last_page: r?.last_page ?? 1,
            total: r?.total ?? 0,
        }));
    }, []);

    const ajaxRequestFunc = useMemo(
        () => createDedupedAjaxRequest(buildRequestParams, fetchPaged, inFlightRef, completedCacheRef),
        [buildRequestParams, fetchPaged]
    );

    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

  
    function matchAny(data, filterParams) {
      var match = false;
      const regex = RegExp(filterParams.value, 'i');
  
      for (var key in data) {
          if (regex.test(data[key]) === true) {
              match = true;
          }
      }
      return match;
    }

    function dateRange(data, filterParams) {
      console.log(data.created_at,filterParams);
      return moment(filterParams.fromDate).isSameOrBefore(data.created_at.substring(0,10)) && moment(filterParams.toDate).isSameOrAfter(data.created_at.substring(0,10));
    }

  function searchTable(){
    setSearchIconColor("active");
    if (searchValue === " ") {
      setSearchValue("");
    }
    setVisibleSearch(false);
    refreshFromStart();
  }

  function searchByDate(){
    setVisibleCalendar(false);
    refreshFromStart();
  }

    const accept = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        rows_to_delete.forEach(element => {
          console.log(element);
          deleteRequest(`/api/painting_conditions/${element.id}`)
              .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                refreshFromStart();
              }).catch((reason) => {
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              })
        });
    }

    const reject = () => {
      toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('ServiceTask.ConfirmDeleteRecord'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: accept
        });
    };

  const rowClick = (e, row) => {
    console.log(e, row);
 };

    const onSelectRow = (data, rows) => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        if(data.length !== 0){
            //TODO dorobit aj contractorov
            if(user.permissions?.includes("add painting"))setCopyIcon(false);
            if(user.permissions?.includes("edit painting"))setEditIcon(false);
            if(user.permissions?.includes("delete painting"))setDeleteIcon(false);
        }
    };

    function PaintingConditionDate(props) {
      const rowData = props.cell.getRow().getData();
      return formatDate(rowData.created_at, true);
    }

    function onEditRow(painting_condition){
      dispatch({type: 'create_new_tab', name: t('Util.Tab.EditPaintingConditions'), translationKey: 'Util.Tab.EditPaintingConditions', legacyLabel: t('Util.Tab.EditPaintingConditions'),page:'PaintingConditionAdd',props:{painting_condition: painting_condition,type:'edit'},mask:'pain003'})
    };
    
    function EditRowFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
    }


    const [draggingItem,setDraggingItem] = useState(null); 
    const [columns,setColumns] = useState([
    { title: '', field: 'id',formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center",width: 44,headerSort:false,resizable:false},
    { title: '', field: 'editor',hozAlign:"center",width: 44,headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false},
    { title: t('PaintingConditionList.Column.OutdoorTemp'), field: 'outdoor_temp',headerFilter:"input",width:200,minWidth:200},
    { title: t('PaintingConditionList.Column.IndoorTemp'), field: 'indoor_temp',headerFilter:"input",width:200,minWidth:200 },
    { title: t('PaintingConditionList.Column.OutdoorHum'), field: 'outdoor_hum',headerFilter:"input",width:200,minWidth:200 },
    { title: t('PaintingConditionList.Column.IndoorHum'), field: 'indoor_hum',headerFilter:"input",width:200,minWidth:200},
    { title: t('PaintingConditionList.Column.Weather'), field: 'weather',headerFilter:"input" ,width:200,minWidth:200},
    { title: t('PaintingConditionList.Column.PhProbe'), field: 'ph_probe',headerFilter:"input" ,width:200,minWidth:200},
    { title: t('PaintingConditionList.Column.PhPhosphate'), field: 'ph_phosphate',headerFilter:"input",width:200,minWidth:200},
    { title: t('PaintingConditionList.Column.TempCheck'), field: 'temp_check',headerFilter:"input",width:260,minWidth:260 },
    { title: t('PaintingConditionList.Column.NaclCheck'), field: 'nacl_check',headerFilter:"input",width:260,minWidth:260},
    { title: t('PaintingConditionList.Column.Note'), field: 'note',headerFilter:"input",width:200,minWidth:200 },
    { title: t('PaintingConditionList.Column.State'), field: 'state',headerFilter:"input",width:200,minWidth:200 },
    { title: t('PaintingConditionList.Column.DateTime'), field: 'custom_date',headerFilter:"input",width:200,minWidth:200,formatter: reactFormatter(<PaintingConditionDate/>) },
    { title: '', field:'created_at', visible:false,sorter: "datetime", sorterParams: { format: "iso",alignEmptyValues:"bottom",} }
  ]);

  const scrollToFirst = () => scrollToFirstUtil(getTable());
  const scrollUp = () => scrollUpUtil(getTable());
  const scrollDown = () => scrollDownUtil(getTable());
  const scrollToLast = () => scrollToLastUtil(getTable());
  function addNewPaintingCondition(){
    const listFilters = getTable()?.getHeaderFilters?.() ?? [];
    const listSorters = getTable()?.getSorters?.() ?? [];
    dispatch({ type: 'create_new_tab', name: t('PaintingCondition.Tab.Add'), translationKey: 'PaintingCondition.Tab.Add', legacyLabel: t('PaintingCondition.Tab.Add'), page: 'PaintingConditionAdd', props: { painting_condition: null, type: 'add', listFilters, listSorters }, mask: 'pain003' });
  }
  function copyPaintingCondition(){
    const row = getTable()?.getSelectedData?.()?.[0];
    const listFilters = getTable()?.getHeaderFilters?.() ?? [];
    const listSorters = getTable()?.getSorters?.() ?? [];
    if (row) dispatch({ type: 'create_new_tab', name: t('PaintingCondition.Tab.Add'), translationKey: 'PaintingCondition.Tab.Add', legacyLabel: t('PaintingCondition.Tab.Add'), page: 'PaintingConditionAdd', props: { painting_condition: row, type: 'add', listFilters, listSorters }, mask: 'pain003' });
  }
  function editPaintingCondition(){
    const row = getTable()?.getSelectedData?.()?.[0];
    const listFilters = getTable()?.getHeaderFilters?.() ?? [];
    const listSorters = getTable()?.getSorters?.() ?? [];
    if (row) dispatch({ type: 'create_new_tab', name: t('Util.Tab.EditPaintingConditions'), translationKey: 'Util.Tab.EditPaintingConditions', legacyLabel: t('Util.Tab.EditPaintingConditions'), page: 'PaintingConditionAdd', props: { painting_condition: row, type: 'edit', listFilters, listSorters }, mask: 'pain003' });
  }

  function confirmPrintDialog(){
    if(printValue=="Zoznam"){
      getTable()?.print?.(false, true)
    }
    else{
      handlePrint();
    }
  }

    function handleDragStart(e, item){ 
      setDraggingItem(item);
      e.dataTransfer.setData('text/plain', ''); 
    }; 

    function handleDragEnd(){ 
      setDraggingItem(null);
    }; 

    function handleDragOver(e){ 
        e.preventDefault(); 
    }; 

    function handleDrop(e, targetItem){ 
        if (!draggingItem) return; 

        const currentIndex = columns.indexOf(draggingItem); 
        const targetIndex = columns.indexOf(targetItem); 

        if (currentIndex !== -1 && targetIndex !== -1) { 
          columns.splice(currentIndex, 1); 
          columns.splice(targetIndex, 0, draggingItem); 
           
        } 
        getTable()?.setColumns?.(columns);
    }; 
  
  function setMask(item,value){
    const columnVisible = {...columnsVisible};
   columnVisible[item] = value;
   console.log(columnVisible);
    const table = getTable();
    for(const val in columnVisible) {
      if(columnVisible[val]==false){
        table?.hideColumn?.(`${val}`);
      } else {
        table?.showColumn?.(`${val}`);
      }
    }
    setColumnsVisible(columnVisible);
  }

  const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const [expandedKeys, setExpandedKeys] = useState({});

  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, []);

    const resetMask = () => resetTabulatorMask({
      page: 'PaintingConditionList',
      defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_PAINTING_CONDITION,
      ref, columns, setColumnsVisible,
    });

    const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
            {
              key: '0_1',
              label: t('Common.SetFilter'),
              icon: 'pi pi-filter',
              command: () => { setUserMaskFilter("PaintingConditionList", "set_filters", null, getTable()?.getHeaderFilters?.() ?? [], null); refreshFromStart(); },
              template: itemRenderer,
          },
            {
              key: '0_2',
              label: t('Common.ClearFilter'),
              icon: 'pi pi-filter-slash',
              command: () => { setUserMaskFilter("PaintingConditionList", "set_filters", null, [], null); getTable()?.clearHeaderFilter?.(); refreshFromStart(); },
              template: itemRenderer,
          },
          {
              key: '0_3',
              label: t('Common.SetSorting'),
              icon: 'pi pi-sort-alt',
              command: () => { setUserMaskFilter("PaintingConditionList", "set_sorters", null, null, null, cleanSorters(getTable()?.getSorters?.() ?? [])); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
              template: itemRenderer,
          },
          {
              key: '0_4',
              label: t('Common.ClearSorting'),
              icon: 'pi pi-sort-alt-slash',
              command: () => { setUserMaskFilter("PaintingConditionList", "set_sorters", null, null, null, []); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
              template: itemRenderer,
          },
          {
              key: '0_5',
              label: t('Common.SetMask'),
              icon: 'pi pi-server',
              command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
              template: itemRenderer,
          },
          {
            key: '0_6',
            label: t('Common.Notifications'),
            icon: 'pi pi-envelope',
            command: () => {openChosenNotificationPreferences('PaintingConditionList');OverflowMenuProvider.setVisible(null);},
            template: itemRenderer,
        },
      ]
    }
  ];function previewFilter(data, filterParams){
    //data - the data for the row being filtered
    //filterParams - params object passed to the filter
    const records = filterParams.records ?? [];
    if (!Array.isArray(records) || !records.includes(data.id)) return false;
    if(filterParams.time_period== "Za deň"){
      return new Date(data.created_at).toDateString() == new Date(filterParams.date).toDateString();
      //return new Date(data.created_at) > new Date(new Date().setDate(new Date().getDate() - 365));
    }
    else if(filterParams.time_period=="Za mesiac"){
      return new Date(data.created_at).getFullYear() == new Date(filterParams.date).getFullYear() && new Date(data.created_at).getMonth() == new Date(filterParams.date).getMonth();
    }
    else if(filterParams.time_period=="Za rok"){
      return new Date(data.created_at).getYear() == new Date(filterParams.date).getYear();
    }
    else if(filterParams.time_period== "Vlastné"){
      let d0 = new Date(filterParams.date[0]);
      let d1 = new Date(filterParams.date[1]);
      if (d0 > d1) [d0, d1] = [d1, d0];
      d0.setHours(0, 0, 0, 0);
      d1.setHours(23, 59, 59, 999);
      const ts = new Date(data.created_at).valueOf();
      return ts >= d0.valueOf() && ts <= d1.valueOf();
    }
    else if(filterParams.time_period== "Všetko"){
       return true;
    }
    return false;
}

function changeMarkings(value){
  const table = getTable();
  if(value){
    const columnVisible = {...columnsVisible};
    for(let val in columnVisible) {
      if(columnVisible[val]!=="id" && columnVisible[val]!=="editor"){
        columnVisible[val]=true;
        table?.showColumn?.(`${val}`);
      }
    };
    setColumnsVisible(columnVisible);
  }
  else{
    const columnVisible = {...columnsVisible};
    for(let val in columnVisible) {
      if(columnVisible[val]!=="id" && columnVisible[val]!=="editor"){
        columnVisible[val]=false;
        table?.hideColumn?.(`${val}`);
      }
    };
    setColumnsVisible(columnVisible);
  }
}



    return(
      <>
      <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewPaintingCondition()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editPaintingCondition()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyPaintingCondition()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => setPrintVisible(true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="search"><button onClick={searchIconColor!=="active" ? () => { setVisibleSearch(true); } : () => { setSearchIconColor(""); setSearchValue(""); refreshFromStart(); }}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="export"><button onClick={() => getTable()?.download?.("xlsx", "data.xlsx", { sheetName: "MyData" })}><ExportIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="refresh"><button onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center align-center ' data-targetid="calendar"><button onClick={() => setVisibleCalendar(true)}><CalendarIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '  data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '  data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog("Podmienky lakovania","PaintingConditionList")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("PaintingConditionList",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '  data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100] " data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
    </IntersectionObserverWrapper>
      </div>
<div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    <div ref={elementRef}>
      <ReactTabulator
      data={undefined}
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          const mask = (state.user_mask_filters || []).filter(m => m.page === "PaintingConditionList");
          const safeParse = (v, fallback) => {
            if (v === null || v === undefined) return fallback;
            if (typeof v === "string") { try { return JSON.parse(v); } catch { return fallback; } }
            return v;
          };
          if (mask.length > 0) {
            const t = getTable();
            const attributes = safeParse(mask[0].attributes, []);
            const filters = safeParse(mask[0].filters, []);
            const sorters = safeParse(mask[0].sorters, []);
            const json_columns = safeParse(mask[0].columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) t?.setColumnLayout?.(attributes);
            if (Array.isArray(filters)) filters.forEach(f => t?.setHeaderFilterValue?.(f.field, f.value));
            if (Array.isArray(sorters) && sorters.length > 0) t?.setSort?.(sorters);
            if (json_columns && typeof json_columns === "object") {
              setColumnsVisible(json_columns);
              for (const column in json_columns) {
                if (json_columns[column] === false) t?.hideColumn?.(column);
                else t?.showColumn?.(column);
              }
            }
            refreshFromStart();
          }
        },
        headerFilterChanged: () => { captureHScroll(); refreshFromStart(); },
        renderComplete: () => restoreHScroll(),
        columnMoved: () => setUserMaskFilter("PaintingConditionList", "column_move", null, null, getTable()?.getColumnLayout?.()),
        columnResized: () => setUserMaskFilter("PaintingConditionList", "column_move", null, null, getTable()?.getColumnLayout?.()),
      }}
      options={{
        layout: "fitColumns",
        renderHorizontal: "virtual",
        movableColumns: true,
        rowHeight: 30,
        printAsHtml: true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.PaintingConditionList'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange: "active",
        ajaxURL: '/api/painting_conditions/paged',
        progressiveLoad: 'scroll',
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        pagination: false,
        ajaxRequestFunc,
        filterMode: 'remote',
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        initialSort: [{ column: "created_at", dir: "desc" }],
      }}/> 
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SearchInListByDate')} visible={visibleCalendar} style={{ width: '40vw' }} onHide={() => setVisibleCalendar(false)}>
              <div className="flex flex-columns justify-between">
                <label>
                  Od:
                <input
                    value={fromDate} onChange={e => setFromDate(e.target.value)}
                    type="date"
                    className="block w-full px-1 py-1 mr-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                /> 
                </label>
                <label>
                  Do:
                <input
                    value={toDate} onChange={e => setToDate(e.target.value)}
                    type="date"
                    className="block w-full px-1 py-1 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
                </label>
                <button onClick={() => searchByDate()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
              </div>
            </Dialog>
            <Dialog header={t('Common.PrintAs')} visible={printVisible} style={{ width: '40vw' }} onHide={() => setPrintVisible(false)}>
        <div className="flex flex-columns">
          <select 
          value={printValue} onChange={e => setPrintValue(e.target.value)}
          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
            <option value="Zoznam">Zoznam</option>                      
          </select>
          <button onClick={() => confirmPrintDialog()} className='w-20 ml-8 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.PrintUpper')}</button>
        </div>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2 || index==columns.length-1) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                        draggable="true"
                        onDragStart={(e) =>  
                            handleDragStart(e, item)} 
                        onDragEnd={() => handleDragEnd()} 
                        onDragOver={(e) => handleDragOver(e)} 
                        onDrop={(e) => handleDrop(e, item)} 
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
          <button onClick={() => {setUserMaskFilter("PaintingConditionList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('TaskTemplateList.MaskSave')}</button>
        </div>
      </Dialog>
      
      </div> 
 </>
    )

}

/* 
<table
          class="min-w-full border text-left text-sm font-light bg-white dark:border-neutral-500">
          <thead class="font-medium border-b bg-gray-400 dark:border-neutral-500">
            <tr>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">
                Meno 
              </th>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">{t('Common.Department')}</th>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">
                ID
              </th>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">
                Email
              </th>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">{t('Ui.R67.Datum_nastupu')}</th>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">{t('EmployeeList.Column.DateOfDeparture')}</th>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">
              </th>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">
              </th>
              <th
                scope="col"
                class=" px-6 py-4 dark:border-neutral-500">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-b dark:border-neutral-500">
              <td
                class="whitespace-nowrap  px-6 py-4 font-medium dark:border-neutral-500">
                Mark
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                Otto
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                123456
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                mark@otto.com
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                01.01.2023
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                
              </td>
              <td><a class="whitespace-nowrap px-6 py-4 text-blue-500 hover:text-blue-700" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
                </a>
              </td>
              <td><a class="whitespace-nowrap px-6 py-4 text-blue-500 hover:text-blue-700" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path><polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
                </svg>
                </a>
              </td>
            </tr>
            <tr class="border-b dark:border-neutral-500">
              <td
                class="whitespace-nowrap  px-6 py-4 font-medium dark:border-neutral-500">
                Jacob
              </td>
              <td
                class="whitespace-nowrap px-6 py-4 dark:border-neutral-500">
                Thornton
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                123456
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                jacob@thorton.com
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                01.01.2023
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 dark:border-neutral-500">
                05.04.2023
              </td>
              <td><a class="whitespace-nowrap px-6 py-4 text-blue-500 hover:text-blue-700" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
                </a>
              </td>
              <td><a class="whitespace-nowrap px-6 py-4 text-blue-500 hover:text-blue-700" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path><polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
                </svg>
                </a>
              </td>
            </tr>
            <tr class="border-b dark:border-neutral-500">
              <form action="Oddelenie.js" method="post"></form>
              
              <td
                class="whitespace-nowrap  px-6 py-4 font-medium dark:border-neutral-500">
                  <input
                            placeholder={t('PaintingDepartmentForm.Placeholder.EnterDepartment')}
                            type="text"
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 font-medium dark:border-neutral-500">
                  <input
                            placeholder={t('PaintingDepartmentForm.Placeholder.HourlyRate')}
                            type="text"
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                
              </td>
              <td
                class="whitespace-nowrap  px-6 py-4 font-medium dark:border-neutral-500">
                  <input
                            placeholder={t('DepartmentList.Column.DefinedId')}
                            type="text"
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                
              </td>
              <td><a class="whitespace-nowrap px-6 py-4 text-blue-500 hover:text-blue-700" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/><path d="M14 3v5h5M12 18v-6M9 15h6"/>
                </svg>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
*/